// BCM leadership team.
//
// INTERNAL CONTENT NOTE (not rendered on the public site):
// Leader photographs are expected before the fall launch. Add each hosted image
// URL to `photo` and the role card swaps the "Add Image here" placeholder for
// the real photo. Do not add biographies, majors, graduation years, social
// links, or quotes unless BCM supplies them.

export type BcmLeader = {
  id: string
  /** Only the name that was supplied — never invent last names. */
  name: string
  role: string
  /** Hosted URL of a real photo of this leader. Empty until supplied. */
  photo?: string
  /** Override alt text — used when one photo shows more than one person. */
  photoAlt?: string
  /** Internal-only note. Never rendered in the UI. */
  devNote?: string
}

const photos = 'https://cdn.magicpatterns.com/uploads'

export const leadership: BcmLeader[] = [
  // TODO: A headshot for Brad has not been supplied yet — the branded role card
  // shows until a real photo is added here.
  { id: 'brad-crawford', name: 'Brad Crawford', role: 'Director' },
  {
    id: 'gabriela',
    name: 'Gabriela',
    role: 'President',
    photo: `${photos}/pAMwaFNHAgtF8FrP7Uj58V/Gabby_Headshot.jpg`,
  },
  {
    id: 'soren',
    name: 'Soren',
    role: 'Vice President',
    photo: `${photos}/u721DRs6wZHdf6sBPvJtgD/Soren_Headshot.jpg`,
  },
  {
    id: 'paul',
    name: 'Paul',
    role: 'Ministry Partner',
    photo: `${photos}/9rVWf8gF1WAfnXxqQxsJZx/Paul_Headshot.jpg`,
  },
  // Spelling confirmed by BCM: "Rachel".
  {
    id: 'rachel',
    name: 'Rachel',
    role: 'Media Director',
    photo: `${photos}/rBGzadvzTCB1TNrQV2mXAm/Rachel_Headshot.jpg`,
  },
  // Jacob and Christian share one supplied photo, so they share one card.
  {
    id: 'jacob-christian',
    name: 'Jacob & Christian',
    role: 'Co-Worship Leads',
    photo: `${photos}/c8ddhpCiMUVhk5QspJe3CM/Jacob_and_Christian_Headshot.jpg`,
    photoAlt: 'Jacob and Christian, Co-Worship Leads at UCF BCM',
  },
  {
    id: 'bryce',
    name: 'Bryce',
    role: 'Tech Director',
    photo: `${photos}/j8CiyNEStE66dewuLLAS5k/Bryce_Headshot.jpg`,
  },
  {
    id: 'robert',
    name: 'Robert',
    role: 'Outreach Director',
    photo: `${photos}/64aKqkpp44VtwWo8aWk6hC/Robert_Headshot.jpg`,
  },
  {
    id: 'alfredo',
    name: 'Alfredo',
    role: 'Events Director',
    photo: `${photos}/cGzxxTEPvovwZtibxiCMF2/Alfredo_Headshot.jpg`,
  },
]
